import React, { useState } from 'react';
function Demo() {
  const [count, setCount] = useState(0);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-2xl font-bold mb-4"
  }, "React Demo Component"), /*#__PURE__*/React.createElement("p", {
    className: "mb-4"
  }, "Count: ", count), /*#__PURE__*/React.createElement("button", {
    className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
    onClick: () => setCount(count + 1)
  }, "Increment"));
}
export default Demo;